import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DatatableComponent } from '@basis/angular-components';

@Component({
  selector: 'app-btn-data-table',
  template: `
  <p class="btn-data-table-basis">
    <button #btn [name]='name' (click)="tratarClick(btn)" pButton
      [ngClass]="disabled ? 'btn-table-disabled' : ''"
      [class]="_class" type="button" tooltipPosition="{{ tooltipPosition ? tooltipPosition : 'bottom'}}"
      pTooltip="{{!dataTableElement.selectedRow &&  tooltipNotSelectedRecord ? tooltipNotSelectedRecord : tooltip}}">
      <span aria-hidden="true" [class]="_icon"></span>
    </button>
  </p>
  `,
  styles: [
    `
      .btn-data-table-basis { text-align: right !important; }
      .btn-table-disabled { opacity: .35; filter: Alpha(Opacity=35); background-image: none; cursor: auto !important;}
    `
  ]
})
export class BtnDataTableBasisComponent implements OnChanges  {
  /**
   * Basis datatable element
  */
  @Input() dataTableElement: DatatableComponent
  @Input() disabled = false;
  /**
   * Class applied on the button
  */
  @Input() class: string;
  /**
   * button 'name' attribute
  */
  @Input() name = '';
  /**
   * default tooltip text
  */
  @Input() tooltip = '';
  /**
   * tooltip text displayed when button is disabled
  */
  @Input() tooltipNotSelectedRecord = '';
  /**
   * position that tooltip should be displayed
  */
  @Input() tooltipPosition: string;
  /**
   * button icon
  */
  @Input() icon: string;
  /**
   * Click event
  */
  @Output() public clickBtn: EventEmitter<any> = new EventEmitter<any>();

  _class = 'ui-button-icon-only';
  _icon = 'ui-button-icon-left ui-clickable fa fa-fw ui-icon-';

  tratarClick(btn) {
    if (!this.dataTableElement.selectedRow) { return };
    this.clickBtn.emit({ button: btn.name, selection: this.dataTableElement.selectedRow });
  }

  ngOnChanges(changes: SimpleChanges): void {

    this._class = this.class && changes.class ? `${this._class} ${this.class}` : this._class;
    this._icon = this.icon && changes.icon ? `${this._icon}${this.icon}` : this._icon;
  }
}



// WEBPACK FOOTER //
// ./src/app/base/base-fields/components/btn-data-table.ts